/**
 *
 * @param {String} input
 * @returns {IncrementProps}
 */
const getIncrement = (input) => {
  const map = new Map();
  const exec = /^[+-]/.exec(input);
  const operator = exec ? exec[0] : null;
  const value = operator ? input.slice(1) : input;

  map.set("operator", operator);
  map.set("value", value);

  return map;

}

export default getIncrement;